module.exports = __webpack_public_path__ + "img/11.c8c1a8f1.webp";